
import _ from "underscore";
import projectList from "config/projectList.js";
import projectListCountriesHack from "config/projectListCountriesHack.js";

export const getProjectList = (user) => {
  return user && user.username === "andre" ? projectListCountriesHack : projectList;
}

export const getUserPoolProjects = (user, userPool) => {
  const userProjectList = getProjectList(user);
  const availableUserProjects = userPool.map((project) => {
    return { name: userProjectList[project], id: project };
  });
  return  _.filter(availableUserProjects, (proj) => {
    return proj.name;
  });
}